module.exports = __webpack_public_path__ + "a145f6c79e25b9f263039bf55bc10126.svg"


/*****************
 ** WEBPACK FOOTER
 ** ./src/assets/images/labels/logos/minimal-wave.svg
 ** module id = 434
 ** module chunks = 0
 **/